// extracted by mini-css-extract-plugin
export var statItem = "_g8-1";
export var statsRow = "_g8-0";